import { Component, Input, inject } from '@angular/core';
import { SvgComponent } from '@app/components/svg/svg.component';
import { ChildRendererService } from './child-renderer.service';

export interface XMLElementComponent<T> {
  data: T;
}

@Component({
  template: '',
})
export abstract class XMLElementBaseComponent<T = any> implements XMLElementComponent<T> {
  @Input() data!: T;
  @Input() dbId!: string | undefined;
  @Input() provider!: string;

  childRenderService = inject(ChildRendererService);

  registerSvg(svgElement: SvgComponent) {
    this.childRenderService.registerSvgElement(svgElement);
  }
}
